import React, { Component } from "react"
import { Container, Col, Row, Table, FormCheck } from 'react-bootstrap'

import { connect } from "react-redux";

import { displayTractBookDetails, getSearchResultById } from '../../../redux/actions/searchActions'
import SearchPaginator from '../../common/page/SearchPaginator'
import {getPaginatorHelper} from '../../common/page/PaginatorHelper'
import Loading from '../../common/modal/Loading';
import { LOADING_STATUES } from "../../constants/constants";
const componentName = 'SearchResultsTable';

const mapStateToProps = state => {

    return {
        searchResults: state.searchResultsReducer,
        paginationPage: state.searchResultsPaginationReducer,
        searchResultsSort: state.searchResultsSortReducer,     
        filterApplied: state.searchResultsFilterAppliedFilter,
        searchResultsFilter: state.searchResultsFilterTractBookReducer,
        searchResultsVisited: state.searchResultsVisitedReducer
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        select: (id, sourcedDocKey, callback) => {
            if (id) {
                dispatch(displayTractBookDetails(id, sourcedDocKey, callback))
            }
        }, // For some reason, id can be null sometimes, so checking to see if id has a value.
        filterResults: (document, sortKey, sortDirection, callback) => dispatch({ type: 'FILTER_TRACT_BOOK_ID', document, sortKey, sortDirection }, callback())
    }
}

class TractBookSearchResultsTable extends Component {
    state = {
        selectedId: null,
        loadingStatus: ''
    }

    showLoading = () => {
        if (this.state.loadingStatus === '') {
            this.setState({
                loadingStatus: LOADING_STATUES.LOADING
            })
            return true;
        }
        return false;
    }

    hideLoading = (message, status) => {
        if (status === 'ERROR') {
            alert(message);
        }
        this.setState({
            loadingStatus: ""
        })
    }

    handleRowClick = (event) => {
        const clickedId = event.target.closest("tr").id; // find the closest parent tr

        if (this.showLoading() === true) {
            this.setState({ selectedId: clickedId });

            let searchResult = getSearchResultById(this, clickedId);

            this.props.select(clickedId, searchResult.sourcedDocKey, this.hideLoading);
        }
    }

    handleKeyDown = (event) => {
        // 13 is Enter. 
        if (event.type === 'keydown' && event.keyCode === 13) {
            const clickedId = event.target.closest("tr").id; // find the closest parent tr

            if (this.showLoading() === true) {
                this.setState({ selectedId: clickedId });

                let searchResult = getSearchResultById(this, clickedId);

                this.props.select(clickedId, searchResult.sourcedDocKey, this.hideLoading);
            }
        }
    }

    handleCheckFilterLimit = () => {
        if (this.props.searchResultsFilter.totalRecordCount >= 100) {
            this.setState(
            {
                showAlert: true,
                alertMessage: 'You have reached the limit of selecting up to 100 records.'
            });
        }
    }

    handleCheckClick = (event) => {
        const clickedId = event.target.closest("tr").id; // find the closest parent tr
        this.props.searchResults.searchResultList.map((searchResult) => {
            if (searchResult.docId == clickedId) {
                this.props.filterResults(searchResult, this.props.searchResultsSort.sortKey, this.props.searchResultsSort.sortDirection, this.handleCheckFilterLimit);
            }
        });
    }

    handleCheckKeyDown = (event) => {
        // 13 is Enter. 
        if (event.type === 'keydown' && event.keyCode === 13) {
            const clickedId = event.target.closest("tr").id; // find the closest parent tr
            this.props.searchResults.searchResultList.map((searchResult) => {
                if (searchResult.docId == clickedId) {
                    this.props.filterResults(searchResult, this.props.searchResultsSort.sortKey, this.props.searchResultsSort.sortDirection, this.handleCheckFilterLimit);
                }
            });
        }
    }

    checkSelected = (id) => {
        for (const element of this.props.searchResultsFilter.searchResultList) {
            if (element.docId == id) {
                return true;
            }
        }
        return false;
    }

    render() {

        let filteredList = this.props.searchResults.searchResultList;
        const numberOfVisibleRecords = 100;
        let numberOfPages = Math.ceil ( filteredList.length / numberOfVisibleRecords );
		let paginationHelper = getPaginatorHelper(this.props.paginationPage, filteredList, numberOfVisibleRecords);

        let displayResults = paginationHelper.currentPageStartingRecordNumber === paginationHelper.currentPageEndingRecordNumber ? 
                                paginationHelper.currentPageStartingRecordNumber :
                                paginationHelper.currentPageStartingRecordNumber + "-" + paginationHelper.currentPageEndingRecordNumber;

        return (
            <>
        
            <Container fluid="true" style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 50}}>
                    <Table responsive striped bordered hover size="sm" style={{ maxHeight: 600, overflowY: 'auto',  display: 'inline-block'}} >
                        <thead style={{ display: 'table', width: '100%',   tableLayout: 'fixed'}}>
                            <tr>
                                <th className="table-td-xs" scope="col" style={{ width: '4%' }} aria-label="Selection"></th>
                                <th className="table-td-xs" scope="col" style={{ width: '18%' }}>Tract Book ID<br />Recorded Date</th>
                                <th className="table-td-xs" scope="col" style={{ width: '78%' }}>Legal<br />&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody key={this.props.paginationPage} style={{ display: 'table', width: '100%', tableLayout: 'fixed', cursor: "pointer"}} >
                            {
                                paginationHelper.currentPageRecordList.map((searchResult) => {
                                    const legalDescriptionsBadge = searchResult.legalSearchResults && searchResult.legalSearchResults.length > 1 ? "more" : "";
                                    const legalDescriptionOne = searchResult.legalSearchResults && searchResult.legalSearchResults.length > 0 && searchResult.legalSearchResults[0] ? searchResult.legalSearchResults[0].description : '';

                                    let selectedClass = this.state.selectedId == searchResult.docId ? "table-active" : ""; // highlight the selected row
                                    const selected = this.checkSelected(searchResult.docId);
                                    
                                    let cursorStyle = {cursor: 'wait' };
                                    if (searchResult.docId) {
                                        cursorStyle = { cursor: 'pointer' }
                                    }
                                    
                                    return (
                                        <tr tabIndex={0} className={selectedClass} style={cursorStyle} id={searchResult.docId} name={searchResult.sourcedDocKey? searchResult.sourcedDocKey.docKeyNumber : ''} onKeyDown={this.handleKeyDown} onClick={this.handleRowClick}>
                                            { 
                                                selected &&
                                                <td className="table-td-xs" style={{ width: '4%' }} ><FormCheck onKeyDown={this.handleCheckKeyDown} onChange={this.handleCheckClick} checked={true} aria-label="Uncheck to unselect" disabled={this.props.filterApplied}></FormCheck></td>
                                            }
                                            { 
                                                !selected &&
                                                <td className="table-td-xs" style={{ width: '4%' }} ><FormCheck onKeyDown={this.handleCheckKeyDown} onChange={this.handleCheckClick} checked={false} aria-label="Check to select" disabled={this.props.filterApplied}></FormCheck></td>
                                            }
                                            <td className="table-td-xs" style={{ width: '18%' }} ><strong>{searchResult.sourcedDocKey? searchResult.sourcedDocKey.docKeyNumber : '' }</strong><br />{searchResult.recordedDate}<br/></td>
                                            <td className="table-td-xs" style={{ width: '78%' }} >{legalDescriptionOne}&nbsp;<span className='badge badge-light'>{legalDescriptionsBadge}</span></td>
                                      </tr>
                                    )
                                })
                            }
                        </tbody>
                    </Table>
                    <Row>
                        <Col style={{ marginLeft: 4}} ><SearchPaginator style={{justifyContent: 'center'}} componentName={componentName} numberOfVisibleRecords={numberOfVisibleRecords} numberOfPages={numberOfPages} ></SearchPaginator></Col>
					</Row>
                    <Row>
                        <Col style={{ marginLeft: 4}} >Displaying Results: {displayResults} of {filteredList.length}</Col>
                    </Row>
                </Container>
        
            <Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
            </>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TractBookSearchResultsTable);